import { render } from "./DriverStatusApiDocsPage.vue?vue&type=template&id=580d324c&ts=true"
import script from "./DriverStatusApiDocsPage.vue?vue&type=script&lang=ts"
export * from "./DriverStatusApiDocsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__